import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { QuotesCarousel } from '~shared/ui/atoms/QuotesCarousel';

export const StyledLoadingModalWrapper = styled.div`
	display: flex;
	width: 100%;
	max-width: 60rem;
	flex-direction: column;
	align-items: center;
	align-self: center;
	justify-content: center;
	padding: 2.4rem 1.6rem;
	border-radius: var(--radius-l);
	margin-right: auto;
	margin-left: auto;
	background: var(--color-grey-10-solid);
	gap: 8rem;
`;

export const Quote = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: var(--gap-x4);
`;

export const StyledQuotesCarousel = styled(QuotesCarousel)`
	padding-right: 2rem;
	padding-left: 2rem;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--gap-x4);
`;

export const imageCss = css`
	object-fit: contain;
`;
